import React from 'react';
import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { AngularServicesContext } from 'react-app';
import useAngularStateManager from 'shared/hooks/use-angular-state-manager';
import { useSelector } from 'react-redux';
import { NavigationHeaderOrigin } from './navigation-header';

const dashboardStates = [
  'dashboard',
  'mentor-dashboard',
  'learning-journeys',
  'institution-dashboard',
  'course-admin-dashboard',
  'course-supervisor-dashboard',
];

const NavigationLeftElement = ({
  origin,
  leftRef,
  scrolledHeader,
}) => {
  const currentInstitutionId = useSelector((state) => state.app.currentInstitutionId);
  const {
    $state,
    $rootScope,
    CurrentPermissionsManager,
  } = React.useContext(AngularServicesContext);
  const { from } = $state.params;
  const {
    previousParamsEntered,
    previousStatesEntered,
  } = useAngularStateManager();

  const reverseFindIndex = (array, eachHandler) => {
    // eslint-disable-next-line no-plusplus
    for (let i = array.length - 1; i >= 0; i--) {
      if (eachHandler(array[i])) {
        return i;
      }
    }

    return -1;
  };

  const lastDashboardStateIndex = reverseFindIndex(previousStatesEntered, (state) => {
    if (dashboardStates.includes(state.name)) {
      return true;
    }

    return false;
  });

  const shouldGoToDefaultDashboard = lastDashboardStateIndex === -1;

  const lastDashboardState = shouldGoToDefaultDashboard
    ? undefined
    : previousStatesEntered[lastDashboardStateIndex];

  const lastDashboardStateParams = shouldGoToDefaultDashboard
    ? undefined
    : previousParamsEntered[lastDashboardStateIndex];

  const isOrgAdmin = CurrentPermissionsManager.hasOrgAdminPermissions()
    || CurrentPermissionsManager.hasCourseManagerPermissions();

  let backButton = null;
  const handleLhsMenuClick = () => $rootScope.$$childHead.MainGridCtrl.toggleLhsMobile();

  const handleBackClick = () => {
    switch (origin) {
      case NavigationHeaderOrigin.USER_MANAGEMENT: {
        if (from === 'learning-journeys-dashboard') {
          $state.go('learning-journeys', { institutionId: currentInstitutionId });
          break;
        }
        $state.go(from);
        break;
      }
      case NavigationHeaderOrigin.HOME:
      default:
        if (isOrgAdmin) {
          $state.go('learning-journeys', { institutionId: currentInstitutionId });
        } else if (shouldGoToDefaultDashboard) {
          $state.go('root');
        } else {
          $state.go(lastDashboardState.name, lastDashboardStateParams);
        }
        break;
    }
  };
  switch (origin) {
    case NavigationHeaderOrigin.USER_MANAGEMENT:
      backButton = from
        ? (
          <ClickableContainer
            className='back-button hoverable'
            onClick={handleBackClick}
            aria-label={t.DASHBOARD.BACK()}
          >
            <NvIcon size='small' icon='back' className='mr-2' />
            <div className='course-subtitle'>
              {t.DASHBOARD.BACK()}
            </div>
          </ClickableContainer>
        )
        : null;
      break;
    case NavigationHeaderOrigin.HOME:
    default:
      backButton = (
        <ClickableContainer
          className='back-button hoverable'
          onClick={handleBackClick}
          aria-label={shouldGoToDefaultDashboard
            ? t.DASHBOARD.GO_TO_DASHBOARD()
            : t.DASHBOARD.BACK_TO_DASHBOARD()}
        >
          <NvIcon size='small' icon='back' className='mr-2' />
          <div className='course-subtitle'>
            {shouldGoToDefaultDashboard
              ? t.DASHBOARD.GO_TO_DASHBOARD()
              : t.DASHBOARD.BACK_TO_DASHBOARD()}
          </div>
        </ClickableContainer>
      );
  }
  return (
    <div
      ref={leftRef}
      className={`left${scrolledHeader ? ' scrolled' : ''}`}
    >
      <div className='lhs-menu'>
        <ClickableContainer
          onClick={handleLhsMenuClick}
          aria-label={t.LHS.OPEN_LHS()}
        >
          <NvIcon icon='menu' size='small' />
        </ClickableContainer>
      </div>
      { backButton }
    </div>
  );
};

export default NavigationLeftElement;
